// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__gJxxC","col":"styles_col__2ZwaO"};